import { Actions } from '../actions/organizationUserGroupsAndRoles';
import { AxiosError } from 'axios';
import { DeepReadonly } from 'utility-types';
import { IOrganizationUserGroupsAndRoles } from '../interfaces/organizationUserGroupsAndRoles';

export type State = DeepReadonly<{
  isFetching: boolean;
  organizationUserGroupsAndRoles: IOrganizationUserGroupsAndRoles | null;
  error: AxiosError | null;
}>;

export const initialState: State = {
  isFetching: false,
  organizationUserGroupsAndRoles: null,
  error: null
};

export function reducer(state: State = initialState, action: Actions): State {
  switch (action.type) {
    case 'FETCH_ORGANIZATION_USER_GROUPS_AND_ROLES_REQUEST':
      return {
        ...state,
        isFetching: true
      };
    case 'FETCH_ORGANIZATION_USER_GROUPS_AND_ROLES_SUCCESS':
      return {
        isFetching: false,
        organizationUserGroupsAndRoles: action.payload,
        error: null
      };
    case 'FETCH_ORGANIZATION_USER_GROUPS_AND_ROLES_FAILURE':
      return {
        ...state,
        isFetching: false,
        organizationUserGroupsAndRoles: null,
        error: action.error
      };
    default:
      return state;
  }
}
